import React from 'react';

/**
 * PhoneMockup — Dark iPhone frame containing a screenshot.
 * Renders the image at the full screen aspect (9:19.5).
 */
export const PhoneMockup = ({ src, alt, className = '', testid }) => {
    return (
        <div
            data-testid={testid}
            className={`iphone-frame animate-float ${className}`}
        >
            <div className="screen">
                <img
                    src={src}
                    alt={alt}
                    className="absolute inset-0 w-full h-full object-cover object-top"
                    loading="lazy"
                    draggable={false}
                />
            </div>
        </div>
    );
};

export default PhoneMockup;
